import store from '@/store';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import '@/amplify';
import { Auth } from '@aws-amplify/auth';
import * as Sentry from '@sentry/vue';
import AppConfig from '@/AppConfig';
import { Team, User } from '@/classes/auth';

// FIXME clean up
export default class Authenticator {
  static authUrl: string = AppConfig.getAuthServiceUrl() || '';

  static async init(): Promise<void> {
    try {
      let token = (await Auth.currentSession()).getIdToken().getJwtToken();

      await Promise.all([store.dispatch('auth/setTokenV1', token), store.dispatch('auth/setToken', token)]);

      axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
        token = (await Auth.currentSession()).getIdToken().getJwtToken();
        const authHeader = `Bearer ${token}`;

        if (config.headers) {
          config.headers.Authorization = authHeader;
        } else {
          config.headers = {
            Authorization: authHeader,
          };
        }

        return config;
      });

      await this.fetchUser();
    } catch (e) {
      console.error(e);

      return;
    }
  }

  static async fetchUser(): Promise<void> {
    await store.dispatch('layout/setLoadingIndicator', true);
    await axios
      .get(AppConfig.getAPIBaseUrl() + '/user/authenticated')
      .then((response) => {
        this.setUser(response.data);
        this.setTeam(response.data);
      })
      .catch((error: AxiosError) => {
        window.console.log('Error on authentication', error);
        Sentry.captureException(error);
        this.logout();
      })
      .finally(() => {
        store.dispatch('layout/setLoadingIndicator', false);
      });
  }

  // FIXME do not use as property, but use inline
  public static getUser(): User {
    return store.state.auth.user;
  }

  public static getTeam(): Team {
    return store.state.auth.team;
  }

  public static isAuthenticated(): boolean {
    return this.getUser().id > 0;
  }

  private static async setUser(user: User): Promise<void> {
    await store.dispatch('auth/setUser', user);
  }

  private static async setTeam(user: User): Promise<void> {
    await store.dispatch('auth/setTeam', user.team);
  }

  public static async logout(): Promise<void> {
    await store.dispatch('auth/logout');

    window.location.href = `${this.authUrl}/logout`;
  }
}
